import { string, traveler as travelerUtils, travelerInputs } from '@eti/utils';
import { formValueSelector } from 'redux-form';
const getTravelerFirstName = (form, state, travelerIndex) => formValueSelector(form)(state, travelerUtils.getTravelerFormSectionName(String(travelerIndex), travelerInputs.FIRST_NAME)) || null;
const getTravelerLastName = (form, state, travelerIndex) => formValueSelector(form)(state, travelerUtils.getTravelerFormSectionName(String(travelerIndex), travelerInputs.LAST_NAME)) || null;
export const getTravelerNames = (form, state, travelers) => travelers === null || travelers === void 0 ? void 0 : travelers.reduce((names, traveler, index) => {
  const firstName = getTravelerFirstName(form, state, index);
  const lastName = getTravelerLastName(form, state, index);
  return firstName && lastName ? [...names, {
    travelerId: traveler.id,
    fullName: `${firstName} ${lastName}`,
    initials: travelerUtils.getInitials(firstName, lastName),
    firstName,
    lastName
  }] : names;
}, []);
export const getTravelerName = (travelerId, travelerNames = [], defaultTravelerLabel, travelerIndex) => {
  const travelerWithName = travelerNames === null || travelerNames === void 0 ? void 0 : travelerNames.find(traveler => (traveler === null || traveler === void 0 ? void 0 : traveler.travelerId) === travelerId);
  return travelerWithName ? travelerWithName.fullName : string.insertArgument(defaultTravelerLabel, travelerIndex);
};
//# sourceMappingURL=travelerNames.js.map